// extracted by mini-css-extract-plugin
module.exports = {"tags":"_9e1425b4d3--tags--XX_6a","tags__link":"_9e1425b4d3--tags__link--JTFNr"};